import clsx from 'clsx'
import React from 'react'

import SvgClubTrendhim from '@Assets/SVG/ClubTrendhim'
import { DrawerPageAsync } from '@Components/Drawer/Page'
import { SideCartContext } from '@Domains/Cart/Context/SideCartContextProvider'
import { useClub } from '@Domains/Club/Hook'
import { PageType } from '@Generated/graphql'
import { useTranslation } from '@Globals/Translations'

import styles from './ClubSignUpBanner.module.scss'

export const ClubSignUpBanner = ({
  children,
  className,
}: {
  children?: React.ReactNode
  className?: string
}) => {
  const { t, tDanger } = useTranslation()
  const { isLoggedIn } = useClub()
  const { cartSummary } = React.useContext(SideCartContext)

  const showButtons = !isLoggedIn

  return (
    <div className={clsx(styles.clubSignUpBanner, className)}>
      <span className={styles.text}>
        <SvgClubTrendhim />
        {!isLoggedIn && children}
      </span>
      {showButtons && (
        <div className={styles.buttons}>
          <DrawerPageAsync
            pageID="56"
            pageType={PageType.Modal}
            sourceID="footer"
            triggerRender={triggerProps => (
              <button
                {...triggerProps}
                className={styles.join}
                type="button"
              >
                {t('common:TRENDHIMCLUB_JOIN_LABEL')}
              </button>
            )}
          />
        </div>
      )}
      {isLoggedIn && (
        <p className={styles.balance} {...tDanger('common:TRENDHIMCLUB_AVAILABLE_CASHBACK_AMOUNT', { amount: cartSummary?.club?.balance?.format || 0 })} />
      )}
    </div>
  )
}

